import type { U2000SearchParameter } from '../../u2000Core/reducer/formReducer/U2000SearchState';

/** Taille de page alignée sur le défaut U3139 (directives BL-0643). */
export const U3121_PROJECT_MINUTES_PAGE_SIZE = 25;

/** Filtre recherche U3139 pour les minutes d'un projet (tri n° minute ASC). */
export function u3121BuildProjectMinutesSearchParameter(projectId: string): U2000SearchParameter {
  const id = projectId.trim();
  return {
    criterias: [
      {
        type: 'string',
        field: 'project.id',
        operator: 'equals',
        value: id,
      },
    ],
    fields: [],
    sortedFields: [{ name: 'minuteNumber', sortOrder: 'ASC' }],
  };
}
